module.exports = __webpack_public_path__ + "static/akinkugbe-54128f4a950ab54a61af4640e88d0257.png";